/* eslint-disable @typescript-eslint/no-explicit-any */
import { ref, watch , onMounted, type Ref } from 'vue'
import { useI18n } from 'vue-i18n'
import moment from 'moment-jalaali'
import { enToFaNum } from '@/helpers'
import type { Messages } from '@/types/i18n'

type Direction = 'rtl' | 'ltr'

interface UseLocaleReturn {
  locale: Ref<any>
  direction: Ref<Direction>
  toggleLocale: () => void
  formatDate: (date: Date) => string
  formatTime: (date: Date) => string
  t: any
}

export function useLocale(): UseLocaleReturn {
  const { locale, t } = useI18n<{ message: Messages }>()
  const direction = ref<Direction>(String(locale.value) === 'fa' ? 'rtl' : 'ltr')

  // Watch for changes in direction and update document classes
  watch(
    direction,
    (newDirection) => {
      // Remove both classes first
      document.documentElement.classList.remove('rtl', 'ltr')
      // Add the new direction class
      document.documentElement.classList.add(newDirection)
      // Update dir attribute
      document.documentElement.dir = newDirection
    },
    { immediate: true },
  )

  const toggleLocale = (): void => {
    locale.value = (String(locale.value) === 'fa' ? 'en' : 'fa') as 'en-US';
    direction.value = String(locale.value) === 'fa' ? 'rtl' : 'ltr';
    localStorage.setItem('i18n', locale.value); // ذخیره زبان
  };

  const formatDate = (date: Date): string => {
    if (String(locale.value) === 'fa') {
      return enToFaNum(moment(date).format('jYYYY/jMM/jDD'))
    }
    return moment(date).format('YYYY/MM/DD')
  }

  const formatTime = (date: Date): string => {
    if (String(locale.value) === 'fa') {
      return enToFaNum(moment(date).format('HH:mm:ss'))
    }
    return moment(date).format('HH:mm:ss')
  }

  onMounted(() => {
    let savedLocale = localStorage.getItem('i18n') as 'en-US' | 'fa' | null;
    if (savedLocale) {
      locale.value = savedLocale as 'en-US';
      direction.value = savedLocale === 'fa' ? 'rtl' : 'ltr';
    }
  });

  return {
    locale,
    direction,
    toggleLocale,
    formatDate,
    formatTime,
    t,
  }
}
